import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Navbar from './components/Navbar';
import Footer from './components/Footer';

// Pages
import Homepage from './pages/Homepage';
import DoctorListing from './pages/DoctorListing';
import DoctorProfile from './pages/DoctorProfile';
import BookingFlow from './pages/BookingFlow';
import UserDashboard from './pages/UserDashboard';

import BlogListing from './pages/BlogListing';
import BlogDetail from './pages/BlogDetail';

import BookAppointment from './pages/BookAppointment';
import BlogPreventiveCare from './pages/BlogPreventiveCare';
import BlogHealthyHabits from './pages/BlogHealthyHabits';
import BlogClearAligners from './pages/BlogClearAligners';
import BlogBackPain from './pages/BlogBackPain';
import BlogChildFever from './pages/BlogChildFever';
import BlogDentalImplants from './pages/BlogDentalImplants';
import BlogKneePain from './pages/BlogKneePain';
import BlogNutritionDiabetes from './pages/BlogNutritionDiabetes';
import BlogAnxiety from './pages/BlogAnxiety';
import BlogObesity from './pages/BlogObesity';
import BlogRootCanal from './pages/BlogRootCanal';
import BlogOccupationalTherapy from './pages/BlogOccupationalTherapy';
import BlogHomeopathy from './pages/BlogHomeopathy';
import BlogPsychotherapy from './pages/BlogPsychotherapy';
import DrSarojRustgi from './pages/DrSarojRustgi';
import DrDeepanshuMalik from './pages/DrDeepanshuMalik';
import DrUtkarshSingh from './pages/DrUtkarshSingh';
import DrMayankNagpal from './pages/DrMayankNagpal';
import DrRohitMehta from './pages/DrRohitMehta';
import DrNeha from './pages/DrNeha';
import DrRuchirKapoor from './pages/DrRuchirKapoor';
import DrSudeepKumar from './pages/DrSudeepKumar';
import DrKinjuMishra from './pages/DrKinjuMishra';
import MsMansiChawla from './pages/MsMansiChawla';
import DrLovleenPuriKapur from './pages/DrLovleenPuriKapur';
import DrMonikaChauha from './pages/DrMonikaChauha';
import DrRituAggarwal from './pages/DrRituAggarwal';
import DrLubnaKamal from './pages/DrLubnaKamal';
import DrPujaDhande from './pages/DrPujaDhande';
import DrVenkataKripa from './pages/DrVenkataKripa';
import DrSandeepSangwan from './pages/DrSandeepSangwan';
import DrAmandeepKaur from './pages/DrAmandeepKaur';
import DrAbhimanyuSangwan from './pages/DrAbhimanyuSangwan';
import DrParasDhhaka from './pages/DrParasDhhaka';
import DrNehaRions from './pages/DrNehaRions';
import DrNareshKumar from './pages/DrNareshKumar';
import DrMadan from './pages/DrMadan';
import DrVickySangwan from './pages/DrVickySangwan';
import DrManoj from './pages/DrManoj';
import DrVarunGaur from './pages/DrVarunGaur';
import DrTruptiVedpathak from './pages/DrTruptiVedpathak';
import DrVannyArora from './pages/DrVannyArora';
import DentalExcellence from './pages/DentalExcellence';
function App() {
  return (
    <Router>
      <div className="min-h-screen flex flex-col bg-white">
        <Navbar />
        <main className="flex-grow pt-20">
          <Routes>
            <Route path="/" element={<Homepage />} />
            <Route path="/doctors" element={<DoctorListing />} />
            <Route path="/doctor/saroj-rustgi" element={<DrSarojRustgi />} />
            <Route path="/doctor/deepanshu-malik" element={<DrDeepanshuMalik />} />
            <Route path="/doctor/utkarsh-singh" element={<DrUtkarshSingh />} />
            <Route path="/doctor/mayank-nagpal"   element={<DrMayankNagpal />} />
            <Route path="/doctor/rohit-mehta" element={<DrRohitMehta />} />
            <Route path="/doctor/neha" element={<DrNeha />} />
            <Route path="/doctor/ruchir-kapoor" element={<DrRuchirKapoor />} />
            <Route path="/doctor/lovleen-puri-kapur" element={<DrLovleenPuriKapur />} />
            <Route path="/doctor/sudeep-kumar" element={<DrSudeepKumar />} />
            <Route path="/doctor/kinju-mishra" element={<DrKinjuMishra />} />
            <Route path="/doctor/mansi-chawla" element={<MsMansiChawla />} />
            <Route path="/doctor/monika-chauhan" element={<DrMonikaChauha />} />
            <Route path="/doctor/ritu-aggarwal" element={<DrRituAggarwal />} />
            <Route path="/doctor/lubna-kamal" element={<DrLubnaKamal />} />
            <Route path="/doctor/puja-dhande" element={<DrPujaDhande />} />
            <Route path="/doctor/venkata-kripa" element={<DrVenkataKripa />} />
            <Route path="/doctor/sandeep-sangwan" element={<DrSandeepSangwan />} />
            <Route path="/doctor/amandeep-kaur" element={<DrAmandeepKaur />} />
            <Route path="/doctor/abhimanyu-sangwan" element={<DrAbhimanyuSangwan />} />
            <Route path="/doctor/paras-dhhaka" element={<DrParasDhhaka />} />
            <Route path="/doctor/neha-rions-diagnostic" element={<DrNehaRions />} />
            <Route path="/doctor/naresh-kumar-akropolis" element={<DrNareshKumar />} />
            <Route path="/doctor/madan-akropolis" element={<DrMadan />} />
            <Route path="/doctor/vicky-sangwan" element={<DrVickySangwan />} />
            <Route path="/doctor/manoj-rions" element={<DrManoj />} />
            <Route path="/doctor/varun-gaur" element={<DrVarunGaur />} />
            <Route path="/doctor/trupti-vedpathak" element={<DrTruptiVedpathak />} />
<Route path="/doctor/vanny-arora" element={<DrVannyArora />} />
<Route path="/doctor/dental-excellence" element={<DentalExcellence />} />
            <Route path="/doctor/:id" element={<DoctorProfile />} />
            <Route path="/book/:id" element={<BookingFlow />} />
            <Route path="/dashboard" element={<UserDashboard />} />
          
            <Route path="/blog" element={<BlogListing />} />
            <Route path="/blog/:id" element={<BlogDetail />} />
            <Route path="/book-appointment" element={<BookAppointment />} />
           
            <Route path="/blog/preventive-care" element={<BlogPreventiveCare />} />
            <Route path="/blog/healthy-habits" element={<BlogHealthyHabits />} />
            <Route path="/blog/clear-aligners-vs-braces" element={<BlogClearAligners />} />
            <Route path="/blog/back-pain-physiotherapy" element={<BlogBackPain />} />
            <Route path="/blog/child-fever-when-to-see-doctor" element={<BlogChildFever />} />
            <Route path="/blog/dental-implants-guide" element={<BlogDentalImplants />} />
            <Route path="/blog/nutrition-for-diabetes" element={<BlogNutritionDiabetes />} /><Route path="/blog/anxiety-therapy-options" element={<BlogAnxiety />} />
            <Route path="/blog/physiotherapy-knee-pain" element={<BlogKneePain />} />
            <Route path="/blog/obesity-beyond-weight-loss" element={<BlogObesity />} />
            <Route path="/blog/root-canal-myths" element={<BlogRootCanal />} />
            <Route path="/blog/occupational-therapy-children" element={<BlogOccupationalTherapy />} />
            <Route path="/blog/homeopathy-evidence" element={<BlogHomeopathy />} />
            <Route path="/blog/psychotherapy-vs-psychiatry" element={<BlogPsychotherapy />} />
            
          
          </Routes>
        </main>
        <Footer />
      </div>
    </Router>
  );
}

export default App;
